@for (item of numberOfCards; track $index) {
    @if (!isFocusCard()) {
        <mat-card
            [style]="{ width: sizes().width, height: sizes().height }"
            class="mb-1 wide-card"
            [class]="cardType()"
            role="article"
            [attr.aria-labelledby]="'card-title-' + $index"
        >
            <mat-card-content>
                <div class="wide-card-top">
                    @if (show().date) {
                        <div class="skeleton-box date" aria-hidden="true"></div>
                    } @else {
                        <span aria-hidden="true"></span>
                    }
                    @if (show().tags) {
                        <div class="skeleton-box top-right" aria-hidden="true"></div>
                    } @else {
                        <span aria-hidden="true"></span>
                    }
                </div>
                <div class="wide-card__content">
                    @if (show().title) {
                        <mat-card-title [attr.id]="'card-title-' + $index" class="skeleton-box title" aria-hidden="true"></mat-card-title>
                    }
                    @if (show().description) {
                        <p class="skeleton-box description" aria-hidden="true"></p>
                    }
                </div>
            </mat-card-content>
        </mat-card>
    }
}
@for (item of numberOfCards; track $index) {
    @if (isFocusCard()) {
        <mat-card
            [style]="{ width: sizes().width, height: sizes().height }"
            class="focus-card mb-1"
            [class]="cardType()"
            role="article"
            [attr.aria-labelledby]="'card-title-' + $index"
        >
            <div class="skeleton-box image"></div>
            <mat-card-content class="card-content">
                <div class="skeleton-box title" aria-hidden="true"></div>
                <div class="bottom">
                    <div class="skeleton-box date" aria-hidden="true"></div>
                    <div class="skeleton-box bottom-right" aria-hidden="true"></div>
                </div>
            </mat-card-content>
        </mat-card>
    }
}
